import { useSelector } from '@xstate/react';

import type { SurveyStore } from '@webapp/common/resources/entities';

import { useStore } from '../store';

import type { SurveyState } from './states';

export const useStateSelector = <T>(selector: (ctx: SurveyStore, state: SurveyState) => T): T => {
    const { useSelector: useRootSelector } = useStore();
    const surveyMachine = useRootSelector((state) => state.context.surveyMachine);
    return useSelector(surveyMachine, (sm) => {
        return selector(sm.context, sm.value as SurveyState);
    });
};
